import { render, staticRenderFns } from "./KanbanBoardProductionOrderItemList.vue?vue&type=template&id=07d94b88"
import script from "./KanbanBoardProductionOrderItemList.vue?vue&type=script&lang=js"
export * from "./KanbanBoardProductionOrderItemList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports